import React, {useState} from 'react';
import {View, Text, StyleSheet, Linking, TouchableOpacity} from 'react-native';
import CustomCheckBox from '../../../components/checkBox/checkBox';
import { COLOR_GREY } from '../../../style';

const GHATermsAndCondition = props => {
  const {termsAndCondition, GHAPrivacyPolicy} = props || {};

  const openURL = url => {
    if (typeof url === 'string') {
      Linking.openURL(url).catch(err =>
        console.error("Couldn't load page", err),
      );
    } else {
      console.error('Invalid URL:', url);
    }
  };

  return (
    <View style={styles.checkboxContainer}>
      <CustomCheckBox />
      <Text style={styles.checkboxText}>
        BY ENROLLING AS A VICEROY DISCOVERY MEMBER, I AGREE TO THE{' '}
        <TouchableOpacity onPress={() => openURL(termsAndCondition)}>
          <Text style={styles.linkText}>TERMS & CONDITIONS</Text>
        </TouchableOpacity>{' '}
        INCLUDING THE{' '}
        <TouchableOpacity onPress={() => openURL(GHAPrivacyPolicy)}>
          <Text style={styles.linkText}>GHA DISCOVERY PRIVACY POLICY</Text>
        </TouchableOpacity>
        , CAN STORE AND PROCESS MY DATA FOR THE PURPOSES OF RECOGNISING AND
        REWARDING STAYS IN HOTELS ACROSS THE GHA DISCOVERY NETWORK.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 15,
  },
  checkboxText: {
    marginLeft: 12,
    fontSize: 14,
    color: COLOR_GREY,
    flex: 1,
  },
  linkText: {
    fontWeight: 'bold',
    color: COLOR_GREY,
  },
});

export default GHATermsAndCondition;
